export default {
  title: {
    en: 'Get more great products for less',
  },
  text: {
    en: `
      You've been busy updating your queue. You can try these
      scents faster and save on each one when you upgrade!
    `,
  },
  planItem: {
    en: `
      {
        value, select,
          0 {1 Product = $14.95/month}
          1 {2 Products = $25 (save $4.90)}
          2 {3 Products = $35 (save $9.85)}
      }
    `,
  },
  buttonClose: {
    en: 'Close',
  },
}
